// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppShortsManage.css */

.shorts-manage {
    width: 100%;
}

.shorts-manage h2 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 30px;
    color: #ffffff;
}

/* 등록 */

.shorts-form {
    display: flex;
    gap: 12px;
    margin-bottom: 30px;
}

.shorts-form input {
    flex: 1 1;
    height: 52px;
    padding: 0 18px;
    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 14px;
    background: rgba(255,255,255,0.06);
    color: #ffffff;
    font-size: 15px;
}

.shorts-form button {
    width: 120px;
    border: none;
    border-radius: 14px;
    background: linear-gradient(
            135deg,
            #6f3cff,
            #2d9cff
    );
    color: white;
    font-weight: 700;
    cursor: pointer;
}

/* 목록 */

.shorts-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* 카드 */

.shorts-card {

    display: flex;

    align-items: center;

    gap: 20px;

    padding: 18px;

    border-radius: 20px;

    background: rgba(255,255,255,0.04);

    border: 1px solid rgba(255,255,255,0.08);
}

/* 썸네일 */

.shorts-card img {

    width: 80px;

    height: 142px;

    object-fit: cover;

    border-radius: 10px;

    flex-shrink: 0;

    background: #111;
}

/* 정보 */

.shorts-info {

    flex: 1 1;

    display: flex;

    flex-direction: column;

    justify-content: center;

    gap: 12px;

    min-height: 142px;
}

.shorts-info h4 {

    margin: 0;

    color: #ffffff;

    font-size: 18px;

    font-weight: 700;

    line-height: 1.5;

    word-break: break-word;
}

/* 버튼 */

.shorts-actions {

    display: flex;

    gap: 10px;

    flex-wrap: wrap;
}

.video-btn,
.edit-btn,
.delete-btn {

    height: 38px;

    padding: 0 16px;

    border: none;

    border-radius: 10px;

    color: white;

    font-size: 13px;

    font-weight: 600;

    cursor: pointer;

    text-decoration: none;

    display: flex;

    align-items: center;

    justify-content: center;
}

.video-btn {
    background: #6f3cff;
}

.edit-btn {
    background: #2d9cff;
}

.delete-btn {
    background: #ff4d67;
}

/* 팝업 */

.modal-overlay {

    position: fixed;

    top: 0;

    left: 0;

    width: 100vw;

    height: 100vh;

    background: rgba(0,0,0,0.8);

    display: flex;

    justify-content: center;

    align-items: center;

    z-index: 99999;
}

.modal-box {

    width: 500px;

    max-width: 92vw;

    padding: 28px;

    border-radius: 20px;

    background: #111;

    border: 1px solid rgba(255,255,255,0.08);
}

.modal-box h3 {

    color: white;

    margin-bottom: 20px;
}

.modal-box input {

    width: 100%;

    height: 50px;

    padding: 0 16px;

    border-radius: 12px;

    background: rgba(255,255,255,0.05);

    border: 1px solid rgba(255,255,255,0.1);

    color: white;

    box-sizing: border-box;
}

.modal-buttons {

    display: flex;

    justify-content: flex-end;

    gap: 10px;

    margin-top: 20px;
}

/* 모바일 */

@media (max-width: 900px) {

    .shorts-card {

        flex-direction: column;

        align-items: center;
    }

    .shorts-card img {

        width: 100px;

        height: 178px;
    }

    .shorts-info {

        min-height: auto;

        width: 100%;
    }

    .shorts-actions {

        width: 100%;
    }

    .video-btn,
    .edit-btn,
    .delete-btn {

        flex: 1 1;
    }

    .shorts-form {

        flex-direction: column;
    }

    .shorts-form button {

        width: 100%;

        height: 52px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AppShortsManage.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,OAAO;;AAEP;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,eAAe;IACf,wCAAwC;IACxC,mBAAmB;IACnB,kCAAkC;IAClC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB;;;;KAIC;IACD,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA,OAAO;;AAEP;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB,kCAAkC;;IAElC,wCAAwC;AAC5C;;AAEA,QAAQ;;AAER;;IAEI,WAAW;;IAEX,aAAa;;IAEb,iBAAiB;;IAEjB,mBAAmB;;IAEnB,cAAc;;IAEd,gBAAgB;AACpB;;AAEA,OAAO;;AAEP;;IAEI,SAAO;;IAEP,aAAa;;IAEb,sBAAsB;;IAEtB,uBAAuB;;IAEvB,SAAS;;IAET,iBAAiB;AACrB;;AAEA;;IAEI,SAAS;;IAET,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;;IAEhB,sBAAsB;AAC1B;;AAEA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,SAAS;;IAET,eAAe;AACnB;;AAEA;;;;IAII,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,qBAAqB;;IAErB,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,OAAO;;AAEP;;IAEI,eAAe;;IAEf,MAAM;;IAEN,OAAO;;IAEP,YAAY;;IAEZ,aAAa;;IAEb,2BAA2B;;IAE3B,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB,cAAc;AAClB;;AAEA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,aAAa;;IAEb,mBAAmB;;IAEnB,gBAAgB;;IAEhB,wCAAwC;AAC5C;;AAEA;;IAEI,YAAY;;IAEZ,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;;IAEX,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;;IAEnB,kCAAkC;;IAElC,uCAAuC;;IAEvC,YAAY;;IAEZ,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;;IAEb,yBAAyB;;IAEzB,SAAS;;IAET,gBAAgB;AACpB;;AAEA,QAAQ;;AAER;;IAEI;;QAEI,sBAAsB;;QAEtB,mBAAmB;IACvB;;IAEA;;QAEI,YAAY;;QAEZ,aAAa;IACjB;;IAEA;;QAEI,gBAAgB;;QAEhB,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;;;;QAII,SAAO;IACX;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;;QAEX,YAAY;IAChB;AACJ","sourcesContent":["/* AppShortsManage.css */\n\n.shorts-manage {\n    width: 100%;\n}\n\n.shorts-manage h2 {\n    font-size: 32px;\n    font-weight: 700;\n    margin-bottom: 30px;\n    color: #ffffff;\n}\n\n/* 등록 */\n\n.shorts-form {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 30px;\n}\n\n.shorts-form input {\n    flex: 1;\n    height: 52px;\n    padding: 0 18px;\n    border: 1px solid rgba(255,255,255,0.15);\n    border-radius: 14px;\n    background: rgba(255,255,255,0.06);\n    color: #ffffff;\n    font-size: 15px;\n}\n\n.shorts-form button {\n    width: 120px;\n    border: none;\n    border-radius: 14px;\n    background: linear-gradient(\n            135deg,\n            #6f3cff,\n            #2d9cff\n    );\n    color: white;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n/* 목록 */\n\n.shorts-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n/* 카드 */\n\n.shorts-card {\n\n    display: flex;\n\n    align-items: center;\n\n    gap: 20px;\n\n    padding: 18px;\n\n    border-radius: 20px;\n\n    background: rgba(255,255,255,0.04);\n\n    border: 1px solid rgba(255,255,255,0.08);\n}\n\n/* 썸네일 */\n\n.shorts-card img {\n\n    width: 80px;\n\n    height: 142px;\n\n    object-fit: cover;\n\n    border-radius: 10px;\n\n    flex-shrink: 0;\n\n    background: #111;\n}\n\n/* 정보 */\n\n.shorts-info {\n\n    flex: 1;\n\n    display: flex;\n\n    flex-direction: column;\n\n    justify-content: center;\n\n    gap: 12px;\n\n    min-height: 142px;\n}\n\n.shorts-info h4 {\n\n    margin: 0;\n\n    color: #ffffff;\n\n    font-size: 18px;\n\n    font-weight: 700;\n\n    line-height: 1.5;\n\n    word-break: break-word;\n}\n\n/* 버튼 */\n\n.shorts-actions {\n\n    display: flex;\n\n    gap: 10px;\n\n    flex-wrap: wrap;\n}\n\n.video-btn,\n.edit-btn,\n.delete-btn {\n\n    height: 38px;\n\n    padding: 0 16px;\n\n    border: none;\n\n    border-radius: 10px;\n\n    color: white;\n\n    font-size: 13px;\n\n    font-weight: 600;\n\n    cursor: pointer;\n\n    text-decoration: none;\n\n    display: flex;\n\n    align-items: center;\n\n    justify-content: center;\n}\n\n.video-btn {\n    background: #6f3cff;\n}\n\n.edit-btn {\n    background: #2d9cff;\n}\n\n.delete-btn {\n    background: #ff4d67;\n}\n\n/* 팝업 */\n\n.modal-overlay {\n\n    position: fixed;\n\n    top: 0;\n\n    left: 0;\n\n    width: 100vw;\n\n    height: 100vh;\n\n    background: rgba(0,0,0,0.8);\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    z-index: 99999;\n}\n\n.modal-box {\n\n    width: 500px;\n\n    max-width: 92vw;\n\n    padding: 28px;\n\n    border-radius: 20px;\n\n    background: #111;\n\n    border: 1px solid rgba(255,255,255,0.08);\n}\n\n.modal-box h3 {\n\n    color: white;\n\n    margin-bottom: 20px;\n}\n\n.modal-box input {\n\n    width: 100%;\n\n    height: 50px;\n\n    padding: 0 16px;\n\n    border-radius: 12px;\n\n    background: rgba(255,255,255,0.05);\n\n    border: 1px solid rgba(255,255,255,0.1);\n\n    color: white;\n\n    box-sizing: border-box;\n}\n\n.modal-buttons {\n\n    display: flex;\n\n    justify-content: flex-end;\n\n    gap: 10px;\n\n    margin-top: 20px;\n}\n\n/* 모바일 */\n\n@media (max-width: 900px) {\n\n    .shorts-card {\n\n        flex-direction: column;\n\n        align-items: center;\n    }\n\n    .shorts-card img {\n\n        width: 100px;\n\n        height: 178px;\n    }\n\n    .shorts-info {\n\n        min-height: auto;\n\n        width: 100%;\n    }\n\n    .shorts-actions {\n\n        width: 100%;\n    }\n\n    .video-btn,\n    .edit-btn,\n    .delete-btn {\n\n        flex: 1;\n    }\n\n    .shorts-form {\n\n        flex-direction: column;\n    }\n\n    .shorts-form button {\n\n        width: 100%;\n\n        height: 52px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
